import { render, staticRenderFns } from "./VerificationEmailForm.vue?vue&type=template&id=05560a64&scoped=true"
import script from "./VerificationEmailForm.vue?vue&type=script&lang=js"
export * from "./VerificationEmailForm.vue?vue&type=script&lang=js"
import style0 from "./VerificationEmailForm.vue?vue&type=style&index=0&id=05560a64&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "05560a64",
  null
  
)

export default component.exports